/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_No_GuidesInputs */



/**
* | output |
* | --- |
* | "No KNP guides yet. Create one to get started." |
*
* @param {Knp_Manager_No_GuidesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_no_guides = /** @type {((inputs?: Knp_Manager_No_GuidesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_No_GuidesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun guide KNP pour le moment. Créez-en un pour commencer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es gibt noch keine KNP-Guides. Erstelle einen, um loszulegen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna guida KNP ancora disponibile. Creane una per iniziare.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пока нет путеводителей по КНП. Создайте свой, чтобы начать.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no hay guías de KNP. Crea una para empezar.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("目前还没有克鲁格国家公园的导览手册。创建一份导览手册即可开始。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("KNPガイドはまだありません。まずは作成しましょう。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अभी तक कोई KNP गाइड उपलब्ध नहीं है। शुरुआत करने के लिए एक गाइड बनाएं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ainda não existem guias sobre o Parque Nacional Kruger. Crie um para começar.")
	return /** @type {LocalizedString} */ ("No KNP guides yet. Create one to get started.")
});